import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ReferralMatchVerificationsStandardBaseComponent } from "../referral-match-verifications-standard-base/referral-match-verifications-standard-base.component";
import { ReferralMatchOption } from "app/core/models/referral-match-option.model";
import { ReferralsStandardListingComponent } from "../../../shared/components/referrals-standard-listing/referrals-standard-listing.component";

@Component({
  selector: 'app-referral-match-verifications-standard-edit',
  templateUrl: './referral-match-verifications-standard-edit.component.html',
  styleUrls: ['./referral-match-verifications-standard-edit.component.scss'],
  imports: [ReferralsStandardListingComponent]
})
export class ReferralMatchVerificationsStandardEditComponent
  extends ReferralMatchVerificationsStandardBaseComponent
  implements OnInit {

  @Output() referralMatchOptionsChanged = new EventEmitter<ReferralMatchOption[]>();

  onReferralMatchOptionChange(option: ReferralMatchOption) {
    this.updateReferralMatchSelection(option);
    this.referralMatchOptionsChanged.emit(this.referralMatchOptions);
  }

  protected isReferralMatchVerificationDisabledOrFormDisabled(_allSelectedRmvs, _resolvedVerification) {
    return false;
  }

  private updateReferralMatchSelection(option: ReferralMatchOption) {
    option.selected = option.verification.office || option.verification.specialty || option.verification.provider;
  }
}
